import script from "./ExportPPTX.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExportPPTX.vue?vue&type=script&lang=ts&setup=true"

import "./ExportPPTX.vue?vue&type=style&index=0&id=018847a8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-018847a8"]])

export default __exports__